/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Initial/view.blocks to change it.
import React from 'react'
import RecordAction from './RecordAction/index'
import SettingsAction from './SettingsAction/index'



/** @type {import('Simple/types.js').View} */
export default function Initial({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/AiRecorder/Content/State/Initial"
  
}) {
  return (<React.Fragment
>
<RecordAction
  viewPath={`${viewPath}/RecordAction`}
/>
<SettingsAction
  viewPath={`${viewPath}/SettingsAction`}
/>
{children}
</React.Fragment>)
}